import React, { Component } from "react";
import { BuildingList } from "./BuildingList";
import TextField from "@material-ui/core/TextField";
import { Building } from "../Building";
import { isNullOrEmpty, isGuid } from "../Util";

export class ClientPortal extends Component {
	state = {
		BuildingNameFilter: "",
		CurrentBuilding: null,
	};
	constructor(props) {
		super(props);
		this.selectBuilding = this.selectBuilding.bind(this);

		var path = document.location.pathname.split("/");
		if (path.length > 2) {
			var bldg = path[2];
			if (!isNullOrEmpty(bldg) && isGuid(bldg)) {
				this.state.CurrentBuilding = bldg;
			}
		}
	}

	selectBuilding(bldg) {
		this.setState({ CurrentBuilding: bldg.buildings_id });
	}

	render() {
		return (
			<div style={{ display: "flex", flex: "1 0 100%", flexDirection: "row" }}>
				<div style={{ display: "flex", flex: "1 0 200px", flexDirection: "column" }}>
					<div style={{ maxHeight: "70px", padding: "8px", backgroundColor: "white" }}>
						<TextField variant="outlined" label="Search for Building" size={"small"} fullWidth={true} onChange={(event) => this.setState({ BuildingNameFilter: event.target.value })} />
					</div>
					<BuildingList building={this.state.CurrentBuilding} IsClientPortal={true} Condensed={true} Filter={this.state.BuildingNameFilter} UsersID="928AB82F-A6BB-4052-A802-B93CF6A71111" onSelectRow={this.selectBuilding}></BuildingList>
				</div>
				<div style={{ display: "flex", flex: "1 1 100%", flexDirection: "column", padding: "4px" }}>
					<Building building={this.state.CurrentBuilding} IsClientPortal={true}></Building>
				</div>
			</div>
		);
	}
}
